var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.partners.length)?_c('section',[_vm._m(0),_c('div',{staticClass:"columns mx-5"},_vm._l((_vm.partners),function(partner){return _c('img',{key:partner.id,staticClass:"column is-one-quarter p-5",attrs:{"src":partner.logo.path,"alt":"logo"}})}),0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"subtitle is-3"},[_c('strong',[_vm._v("N")]),_vm._v("os partenaires")])
}]

export { render, staticRenderFns }